import React from 'react'
import type { InlineInputContentOptions } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import { DateTimeInput } from '../DateTimeInput'
import { LocalCustomDateTime } from '../LocalCustomDateTime'
import { formatConstants, toDate } from '@ztechapps/common.utils'

const DateTimeInlineInput = ({
  name = 'timeStamp',
  displayContent,
  editContent,
  parentInputComponent,
  format,
  inputProps,
  updateParams,
  ...rest
}: any) => {
  const ParentInput = parentInputComponent ?? InlineInput
  if (!format) {
    if (inputProps?.type === 'time') format = 'h:mm A'
    else if (inputProps?.type === 'date') format = formatConstants.date
    else format = formatConstants.dateTime
  }

  displayContent = displayContent ?? ((value: Date | string) => <LocalCustomDateTime format={format} value={value} />)

  updateParams =
    updateParams ??
    (({ updatedValue, _id }: any) => {
      // DateTimeInput is the single source of truth for timezone handling — it already
      // emits a proper UTC ISO string (e.g. "2026-04-04T15:59:00.000Z") via .toISOString().
      // This call is a safe UTC→UTC pass-through: toDate() parses the Z-suffixed string
      // as UTC and .toISOString() writes it back unchanged.
      updatedValue = toDate(updatedValue).toISOString()

      return {
        input: {
          _id,
          [name]: updatedValue,
        },
      }
    })

  return (
    <ParentInput
      {...{
        name,
        ...rest,
        displayContent,
        updateParams,
        editContent:
          editContent ??
          (({ setNewValue, value, inputRef, onBlur, onKeyDown, submitting }: InlineInputContentOptions) => {
            return (
              <DateTimeInput
                submitting={submitting}
                inputRef={inputRef}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                {...{
                  ...inputProps,
                  value,
                  onChange: (e: any) => {
                    setNewValue(e)
                  },
                }}
              />
            )
          }),
      }}
    />
  )
}

export { DateTimeInlineInput }
